/*! js/AngularApp.js 30.0.870 © 2017 Open Education, LLC. */
webpackJsonp([23],{

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(695);


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

/*jslint browser: true, vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
/*global $, google, define, require, window */
(function () {
    'use strict';

    var $ = __webpack_require__(2),
        _ = __webpack_require__(0),
        Backbone = __webpack_require__(1),
        AngularOEPage = __webpack_require__(23),

        template = __webpack_require__(696),
        templateFn = _.template(template);

    window.App = Backbone.View.extend({

        render: function () {
            var me = this;
            this.$el.html(templateFn({
                i18n: i18n
            }));

            AngularOEPage.init();

            return this;
        }

    });
})();


/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports = "<lp2-header></lp2-header>\n<lp2-title-bar page-title=\"<%= i18n.studyBundle.studentInfo.title %>\"></lp2-title-bar>\n<lp2-study-bundle></lp2-study-bundle>\n<lp2-footer></lp2-footer>\n";

/***/ })

},[694]);


// WEBPACK FOOTER //
// js/AngularApp.js